import React from 'react';
import Box from '@mui/material/Box';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import Paper from '@mui/material/Paper';
import HomeIcon from '@mui/icons-material/Home';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import RateReviewIcon from '@mui/icons-material/RateReview';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const MobileBottomNav = ({ handleScroll, openConsultationForm }) => {
    const [value, setValue] = React.useState(0);

    return (
        <Box sx={{ display: { xs: 'block', md: 'none' } }}>
            <Box sx={{ height: 65 }} />
            <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1200, borderTop: '1px solid #E0E0E0' }} elevation={10}>
                <BottomNavigation
                    showLabels
                    value={value}
                    onChange={(event, newValue) => {
                        setValue(newValue);
                    }}
                    sx={{
                        height: 65,
                        bgcolor: '#ffffff',
                        '& .Mui-selected': {
                            color: '#FF6600 !important',
                            '& .MuiSvgIcon-root': {
                                color: '#FF6600',
                            }
                        },
                        '& .MuiBottomNavigationAction-root': {
                            minWidth: 'auto',
                            padding: '6px 0',
                            color: '#8C8C8C',
                        },
                        '& .MuiBottomNavigationAction-label': {
                            fontSize: '11px',
                            fontWeight: 500,
                            mt: 0.5
                        }
                    }}
                >
                    <BottomNavigationAction
                        label="Home"
                        icon={<HomeIcon />}
                        onClick={() => handleScroll('hero')}
                    />
                    <BottomNavigationAction
                        label="Services"
                        icon={<MedicalServicesIcon />}
                        onClick={() => handleScroll('services')}
                    />
                    <BottomNavigationAction
                        label="Reviews"
                        icon={<RateReviewIcon />}
                        onClick={() => handleScroll('testimonials')}
                    />
                    <BottomNavigationAction
                        label="Book Now"
                        icon={<CalendarMonthIcon />}
                        onClick={() => openConsultationForm('mobile-nav')}
                    />
                </BottomNavigation>
            </Paper>
        </Box>
    );
};

export default MobileBottomNav;
